import React, { useEffect, useState, useRef, useCallback } from "react"
import PropTypes from "prop-types"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { withTranslation } from "react-i18next"
import Configs from "../../../config"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import secureLocalStorage from "react-secure-storage"
import moment from "moment"
import { Link } from "react-router-dom"
import { socket } from "utils/Connection"

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false)
  const [loading, setLoading] = useState(false)

  const loggedInUserRef = useRef(secureLocalStorage.getItem("admin_user"))

  const [data, setData] = useState([])

  const fetchEmployeeNotifications = useCallback(async () => {
    const user = loggedInUserRef.current
    if (!user?.id) return
    try {
      const APIdata = await fetchData(
        setLoading,
        `notification/${user.id}`
      )
      if (APIdata?.success) {
        setData(APIdata?.data.reverse())
      }
    } catch (error) {
      console.log(error)
    }
  }, [])

  useEffect(() => {
    fetchEmployeeNotifications()

    const handleNewNotification = () => {
      fetchEmployeeNotifications()
    }

    socket.on("queryReceived", handleNewNotification)
    socket.on("timesheetSubmitted", handleNewNotification)
    socket.on("leaveRequest", handleNewNotification)
    socket.on("unavailabilityReceived", handleNewNotification)

    const pollingInterval = setInterval(() => {
      fetchEmployeeNotifications()
    }, 30000)

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchEmployeeNotifications()
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      socket.off("queryReceived", handleNewNotification)
      socket.off("timesheetSubmitted", handleNewNotification)
      socket.off("leaveRequest", handleNewNotification)
      socket.off("unavailabilityReceived", handleNewNotification)
      clearInterval(pollingInterval)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [fetchEmployeeNotifications])

  const unreadCount = data.filter(n => !n.isRead).length || 0

  const handleMarkAsRead = async notificationId => {
    try {
      await FetchPutData(setLoading, "notification/mark/read", notificationId)

      setData(prev =>
        prev.map(n => (n.id === notificationId ? { ...n, isRead: true } : n))
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
      >
        <i className="bx bx-bell bx-tada text-dark" />
        <span className="badge bg-danger rounded-pill">{unreadCount}</span>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
        <div className="p-3 border-bottom">
          <Row className="align-items-center">
            <Col>
              <h6 className="m-0">{props.t("Notifications")}</h6>
            </Col>
            <div className="col-auto">
              <Link
                to={`${Configs.appurl}notifications`}
                className="fw-medium fs-6"
              >
                View All
              </Link>
            </div>
          </Row>
        </div>

        <SimpleBar style={{ height: "250px" }}>
          {data?.length === 0 && (
            <div
              className=" d-flex justify-content-center align-items-center"
              style={{ height: "250px" }}
            >
              <h6 className="mt-0 mb-1 text-danger">No Notifications Found</h6>
            </div>
          )}
          {data.map(notification => (
            <div
              key={notification.id}
              onClick={() =>
                !notification.isRead && handleMarkAsRead(notification.id)
              }
              className={`text-reset notification-item border-bottom d-block ${
                !notification.isRead ? "bg-light fw-bold" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <div className="py-2 px-3">
                <h6 className="mt-0 mb-1">
                  {!notification.isRead && (
                    <span className="badge bg-primary me-2">New</span>
                  )}
                  {notification.title}
                </h6>
                <div className="font-size-12 text-muted">
                  <p className="mb-1">{notification.description}</p>
                  <p className="mb-0 text-primary text-end">
                    <i className="mdi mdi-clock-outline" />{" "}
                    {moment.utc(notification.createdAt).local().fromNow()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </SimpleBar>
      </DropdownMenu>
    </Dropdown>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(NotificationDropdown)
